import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BlogIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Blog",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M26.91 4.23H9.46a3.05 3.05 0 0 0-3.05 3.05V24.3c0 .49-.4.89-.89.89s-.89-.4-.89-.89V11.65c-.06-.68-.62-1.2-1.31-1.2s-1.25.53-1.31 1.2v12.66c0 1.85 1.45 3.36 3.28 3.46h19.92c2.65 0 4.8-2.15 4.8-4.8V7.29a3.05 3.05 0 0 0-3.05-3.05h-.04Zm.44 18.75c0 1.2-.98 2.17-2.18 2.18H9.02V7.3c0-.24.2-.44.44-.44h17.46c.24 0 .44.2.44.44v15.68ZM12.08 8.6h12.21c.73 0 1.31.59 1.31 1.31v3.48c0 .73-.59 1.31-1.31 1.31H12.08c-.73 0-1.31-.59-1.31-1.31V9.91c0-.72.59-1.31 1.31-1.31m12.21 7.85H12.08c-.68.06-1.2.62-1.2 1.31s.53 1.25 1.2 1.31h12.33c.73 0 1.31-.59 1.31-1.31s-.59-1.31-1.31-1.31h-.11Zm0 4.37H11.97c-.73 0-1.31.59-1.31 1.31s.59 1.31 1.31 1.31H24.4c.73 0 1.31-.59 1.31-1.31s-.59-1.31-1.31-1.31z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M22 27H10c-2.76 0-5-2.24-5-5v-8c0-.55.45-1 1-1s1 .45 1 1v8c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3V8c0-.55-.45-1-1-1H12c-.55 0-1 .45-1 1v14c0 .55-.45 1-1 1s-1-.45-1-1V8c0-1.65 1.35-3 3-3h12c1.65 0 3 1.35 3 3v14c0 2.76-2.24 5-5 5"
      }), /*#__PURE__*/_jsx("path", {
        d: "M22 15h-8c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h8c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1m-7-2h6v-2h-6zM22 19h-8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1M19 23h-5c-.55 0-1-.45-1-1s.45-1 1-1h5c.55 0 1 .45 1 1s-.45 1-1 1"
      })]
    })
  }));
};